import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import before from '../../img/before.svg';
import Big3Common from "../../js/Big3Common";

/* 개발담당:양유빈
 * 화면기능:상품,매장 검색 헤더
 * 세부설명:
*/

export class SearchText extends Component {
    static displayName = SearchText.name;

    constructor(props) {
        super(props);
        this.state = {
            SearchText:""
        };
        //Authentication 설정하지 않거나, 처리하지 않는다고 명시 할때만
        Big3Common.Authentication(this); 

        this.CallBackText = React.createRef();
        this.handle_Change = this.handle_Change.bind(this);
        this.GetSearchTextRef = this.GetSearchTextRef.bind(this);
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
        this.SearchText = "";
    }
    handle_Change(event) {
        let inputValue = event.target.value;
        this.setState({ SearchText: inputValue }); 
        this.SearchText = inputValue;
        if (event.keyCode === 13) {            
            if (this.props.KeyPress !== undefined && this.props.KeyPress !== null) {
                this.props.KeyPress();
                event.preventDefault();
            }
        }
    }
    //검색어 초기화
    handleDelete_Click(event) {
        this.setState({ SearchText: "" });
        this.SearchText = "";
        if (this.props.Blur !== undefined && this.props.Blur !== null) {
            this.props.Blur();
            event.preventDefault();
        }
        if (event.key === "Enter") {
            if (this.props.KeyPress !== undefined && this.props.KeyPress !== null) {
                this.props.KeyPress();
                event.preventDefault();
            }
        }
        event.preventDefault();
    }
    //부모 페이지에 검색값 리턴
    GetSearchTextRef() {
        return this.SearchText;
    }
    //부모에서 검색 키워드를 할당
    SetSearchTextRef(SearchText) {
        this.setState({ SearchText: SearchText })
        this.SearchText = SearchText;
    }
  
    PageLink() {

        if (this.props.LinkUrl !== undefined) {
            return (
                <Link to={this.props.LinkUrl} >
                    <img src={before} alt="이전화면" />
                </Link>
            )
        }
        else if (this.props.HistoryBack !== undefined && this.props.HistoryBack === true) {
            return (
                <div className="before pointer">
                    <Link to={-1} >
                        <img src={before} alt="이전화면" />
                    </Link>
                </div>
            )
        }
        else {
            if (this.props.ComponentUrl !== undefined && this.props.ContentState === undefined) {
                return (
                    <div onClick={() => this.props.RenderComponent(this.props.ComponentUrl)} style={{ cursor: 'pointer' }}>
                        <img src={before} alt="이전화면" />
                    </div>
                );
            }
            else if (this.props.ComponentUrl !== undefined && this.props.ContentState !== undefined) {
                //이전 부모 화면에서 전체 state값을 가져오고 다시 돌려 줌. 상태유지가 필요할때
                return (
                    <div onClick={() => this.props.RenderComponent(this.props.ComponentUrl, this.props.ContentState)} style={{ cursor: 'pointer' }}>
                        <img src={before} alt="이전화면" />
                    </div>
                );
            }

        }
    }
    render() {
        const PageLink = this.PageLink();
        return (
            <header ref={this.CallBackText}>
                <div className="nav">
                    {PageLink}
                    <div className="search_box">
                        <input type="search"
                            inputMode="search"
                            enterKeyHint="search"
                            placeholder="검색어를 입력해주세요."
                            className="form-control"
                            onChange={this.handle_Change}     
                            onKeyUp={this.handle_Change}
                            value={this.state.SearchText}
                        />
                        <div className="search_icon"></div>
                        <div className="search_delete" onClick={this.handleDelete_Click}></div>
                    </div>
                    {/*<Link to="/Search/Similar/SimilarGoods">*/}
                    {/*    <div className="header_icon_box">*/}
                    {/*        <label htmlFor="image-upload" className="image_upload_btn2">*/}
                    {/*        </label>*/}
                    {/*    </div>    */}
                    {/*</Link>*/}
                </div>
            </header>
        );
    }
}
